var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-cabinet-settings-card"},[_c('div',{staticClass:"page-cabinet-settings-card__title",domProps:{"textContent":_vm._s(_vm.title)}}),_c('ui-card-base',[_c('div',{staticClass:"page-cabinet-settings-card__container"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }